import dayjs from 'dayjs';
import { v4 as uuidv4 } from 'uuid';

import type { FeedEntitlementRow, InventoryFeedInput } from '../entitlements-types';

type BuildDraftEntitlementsFromInventoryArgs = {
  persistSelectedRanges?: boolean;
};

export function buildDraftEntitlementsFromInventory(
  feeds: InventoryFeedInput[] = [],
  args: BuildDraftEntitlementsFromInventoryArgs
): FeedEntitlementRow[] {
  const persistSelectedRanges = args.persistSelectedRanges ?? false;

  return feeds.map((feed) => {
    const availabilityStartDate = feed.availabilityStartDate ?? dayjs('2000-01-01').format('YYYY-MM-DD');
    const availabilityEndDate = feed.availabilityEndDate ?? dayjs().format('YYYY-MM-DD');
    const isDayEntitlement = feed.isDayEntitlement ?? false;
    const startDate = persistSelectedRanges ? availabilityStartDate : availabilityEndDate;

    return {
      id: uuidv4(),
      feedId: feed.id,
      name: feed.name,
      startDate: isDayEntitlement ? startDate : startDate.slice(0, 7),
      endDate: isDayEntitlement ? availabilityEndDate : availabilityEndDate.slice(0, 7),
      availabilityStartDate,
      availabilityEndDate,
      isOngoing: feed.isOngoing ?? false,
      onGoingMaxDate: feed.onGoingMaxDate ?? null,
      isDayEntitlement,
      expiryDate: feed.expiryDate ?? null,
      isEdited: feed.isEdited ?? true,
    };
  });
}
